import React from "react";
import { helpers } from "services";
import get from "lodash/get";
import useTranslation from "hooks/useTranslation";

const TableTotalRow = ({ data, currency }) => {
  const { tr } = useTranslation();
  const totalSum = get(data, `total[Реализация]`, 0) + get(data, `total[Сыря]`, 0) + get(data, `total[Полуфабрикат]`, 0);

  return (
    <tr>
      <td className="bg-main"></td>
      <td className="fw-600 bg-main">{tr("Итого")}</td>
      <td className="text-right fw-600 bg-main">
        {helpers.convertToReadable(get(data, `total[Сыря]`, 0))} {currency}
      </td>
      <td className="text-right fw-600 bg-main">
        {helpers.convertToReadable(get(data, `total[Полуфабрикат]`, 0))} {currency}
      </td>
      <td className="text-right fw-600 bg-main">
        {helpers.convertToReadable(get(data, `total[Реализация]`, 0))} {currency}
      </td>
      <td className="text-right fw-600 bg-main">
        {helpers.convertToReadable(totalSum)} {currency}
      </td>
    </tr>
  );
};

export default TableTotalRow;
